import React, { type JSX } from 'react';
import { dialogActions } from './Dialog';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type Props = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly title: string;
  readonly text: string;
  readonly children?: React.ReactNode;
};

export default function InfoDialog({ open, onClose, title, text, children }: Props): JSX.Element {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
        {children}
      </DialogContent>
      <DialogActions sx={dialogActions}>
        <Button autoFocus onClick={onClose} variant="contained" color="secondary" data-testid="close">
          Schließen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
